<app-history [ModuleId]="moduleId" [EntityId]="entityId" ></app-history>